export default __webpack_public_path__ + "static/media/gold.52f99176.png";